import { BaseContainerModel } from "../../base-container.model";
import { bl_crm_organization_hdr_RowClass } from "../../../dbschema";

export class OrganizationCrmHeaderContainerModel extends BaseContainerModel {
	bl_crm_organization_hdr: bl_crm_organization_hdr_RowClass =
		new bl_crm_organization_hdr_RowClass();
}
